import { select } from "@angular-redux/store";
import { Component, Input, OnChanges, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import { ApplicationUser } from "../../../models/application.user.interface";
import {
  CREATED, CANCELLED, IN_PROGRESS, ON_HOLD, PLANNED, PRE_PLANNED, RE_USED, TO_BE_PLANNED, CLOSED, ACCEPTED, LINE_PLANNED, LINE_CREATED,
  LINE_IN_PROGRESS, LINE_CLOSED, LINE_CANCELED, LINE_PREPLANNED, LINE_REUSED
} from "../../../models/status-type.interface";
import { TranslateService } from "@ngx-translate/core";
import { take } from "rxjs/operators";

@Component({
  moduleId: module.id,
  selector: "status-badge",
  templateUrl: "./status-badge.component.html",
})
export class StatusBadgeComponent implements OnChanges, OnInit {

  @select("applicationUser") applicationUser$: Observable<ApplicationUser>;

  @Input() public statusType;
  @Input() public isOrderline: boolean = false;
  @Input() public tooltip: string | null;

  public labelName: string;
  public tagStyle: string;
  private orderlineReuseStatus: number = RE_USED;


  constructor(private translateService: TranslateService) {
  }

  ngOnInit() {
    this.applicationUser$.subscribe((applicationUser: ApplicationUser) => {
      if (applicationUser) {
        this.orderlineReuseStatus = applicationUser.generalSetting.orderlineReuseStatus;
        this.getStatusString();
      }
    });
  }

  public ngOnChanges(): void {
    this.getStatusString();
  }

  public getStatusString(): void {
    if (this.setOrderlinesReusedState()) {
      return;
    }

    switch (this.statusType) {
      case CREATED:
      case LINE_CREATED:
        this.fetchTranslatedLabelName("STATUS.CREATED");
        this.tagStyle = "badge badge-created";
        break;
      case TO_BE_PLANNED:
        this.fetchTranslatedLabelName("STATUS.TO_BE_PLANNED");
        this.tagStyle = "badge badge-to-be-planned";
        break;
      case PLANNED:
      case LINE_PLANNED:
        this.fetchTranslatedLabelName("STATUS.PLANNED");
        this.tagStyle = "badge badge-planned";
        break;
      case IN_PROGRESS:
      case LINE_IN_PROGRESS:
        this.fetchTranslatedLabelName("STATUS.IN_PROGRESS");
        this.tagStyle = "badge badge-in-progress";
        break;
      case LINE_PREPLANNED:
      case PRE_PLANNED:
        this.fetchTranslatedLabelName("STATUS.PRE_PLANNED");
        this.tagStyle = "badge badge-preplanned";
        break;
      case ON_HOLD:
        this.fetchTranslatedLabelName("STATUS.ON_HOLD");
        this.tagStyle = "badge badge-danger";
        break;
      case CANCELLED:
      case LINE_CANCELED:
        this.fetchTranslatedLabelName("STATUS.CANCELLED");
        this.tagStyle = "badge badge-danger";
        break;
      case RE_USED:
      case LINE_REUSED:
        this.setReused();
        break;
      case CLOSED:
      case LINE_CLOSED:
        this.fetchTranslatedLabelName("STATUS.CLOSED");
        this.tagStyle = "badge badge-done";
        break;
      case ACCEPTED:
        this.fetchTranslatedLabelName("STATUS.ACCEPTED");
        this.tagStyle = "badge badge-to-be-planned";
        break;
      default:
        this.fetchTranslatedLabelName("STATUS.UNDEFINED");
        this.tagStyle = "badge badge-danger";
    }
  }

  setOrderlinesReusedState(): boolean {
    if (this.isOrderline && this.statusType == this.orderlineReuseStatus) {
      this.setReused();
      return true;
    }
    return false;
  }

  setReused() {
    this.fetchTranslatedLabelName("STATUS.REUSED");
    this.tagStyle = "badge badge-reused";
  }

  private fetchTranslatedLabelName(translationKey: string): void {
    this.translateService.get(translationKey)
      .pipe(take(1))
      .subscribe((translation: string) => {
        this.labelName = translation;
      });
  }
}
